<template>
  <div class="cashout-admin">
    <el-alert
      title="变现管理沿用原对单数据：发布后待撮合，无独立审核环节。价格统一使用元，草稿不在此列表展示。"
      type="info"
      :closable="false"
    />
    <el-form inline size="small" class="filters" @submit.native.prevent="load(1)">
      <el-form-item label="标题"><el-input v-model="search.title" clearable /></el-form-item>
      <el-form-item label="状态"
        ><el-select v-model="search.status" clearable
          ><el-option
            v-for="(label, value) in statuses"
            :key="value"
            :value="value"
            :label="label" /></el-select
      ></el-form-item>
      <el-form-item label="记录"
        ><el-select v-model="search.deleted"
          ><el-option label="正常记录" value="0" /><el-option label="已删除" value="1" /><el-option
            label="全部"
            value="all" /></el-select
      ></el-form-item>
      <el-button type="primary" @click="load(1)">查询</el-button>
    </el-form>
    <el-table :data="list" v-loading="loading">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="title" label="变现标题" min-width="230" />
      <el-table-column prop="order_no" label="对单编号" min-width="200" />
      <el-table-column label="发布价（元）" width="130"
        ><template slot-scope="s">{{
          Number(s.row.money) === 0 ? '面议' : s.row.money
        }}</template></el-table-column
      >
      <el-table-column label="状态" width="110"
        ><template slot-scope="s"
          ><el-tag :type="Number(s.row.is_delete) ? 'danger' : 'info'">{{
            Number(s.row.is_delete) ? '已删除' : statuses[s.row.status]
          }}</el-tag></template
        ></el-table-column
      >
      <el-table-column label="操作" width="160"
        ><template slot-scope="s">
          <el-button v-auth="'/issueorder/cashoutv2/detail'" type="text" @click="open(s.row, false)"
            >详情</el-button
          >
          <el-button
            v-if="!Number(s.row.is_delete) && Number(s.row.status) !== 20"
            v-auth="'/issueorder/cashoutv2/edit'"
            type="text"
            @click="open(s.row, true)"
            >编辑</el-button
          >
        </template></el-table-column
      >
    </el-table>
    <el-pagination
      :current-page="search.page"
      :page-size="15"
      :total="total"
      layout="total, prev, pager, next"
      @current-change="load"
    />
    <el-dialog
      title="变现信息管理"
      :visible.sync="visible"
      width="900px"
      :close-on-click-modal="false"
    >
      <div v-loading="detailLoading">
        <div v-if="detailError">
          <el-alert title="详情或配置加载失败，请重试" type="error" :closable="false" /><el-button
            @click="open(activeRow, editing)"
            >重新加载</el-button
          >
        </div>
        <div v-else-if="detail">
          <el-alert
            v-if="priceMismatch"
            title="主单金额与新版发布价不一致，当前按主单金额展示；在此保存将同步两处价格。"
            type="warning"
            :closable="false"
          />
          <p class="muted">
            {{ detail.order.order_no }} · {{ detail.status_text }} · 发布者ID
            {{ detail.order.user_id }} ·
            {{ detail.biz.agreement_accepted == 1 ? '发布时已确认规则' : '历史记录未记录规则确认' }}
          </p>
          <el-form label-width="125px" size="small" :disabled="!editing || saving">
            <el-form-item label="标题"
              ><el-input v-model="form.title" maxlength="80"
            /></el-form-item>
            <div class="field-grid">
              <el-form-item v-for="field in selectFields" :key="field.key" :label="field.label">
                <el-select
                  v-model="form[field.key]"
                  :multiple="field.multiple"
                  filterable
                  placeholder="历史未填写，可补充"
                >
                  <el-option
                    v-for="option in fieldOptions(field.key)"
                    :key="option.value"
                    :value="option.value"
                    :label="option.label"
                    :disabled="option.disabled"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="品牌"
                ><el-input v-model="form.brand" maxlength="80"
              /></el-form-item>
              <el-form-item label="所在城市"
                ><el-select v-model="form.city_id" filterable placeholder="历史未填写，可补充"
                  ><el-option
                    v-for="city in cityOptions"
                    :key="city.value"
                    :value="city.value"
                    :label="city.label"
                    :disabled="city.disabled" /></el-select
              ></el-form-item>
              <el-form-item label="数量"
                ><el-input-number v-model="form.quantity" :min="1" :max="99999" :precision="0"
              /></el-form-item>
              <el-form-item label="发布价（元）"
                ><el-input v-model="form.sale_price" placeholder="0 表示价格面议"
              /></el-form-item>
              <el-form-item label="参考原价（元）"
                ><el-input v-model="form.estimate_value"
              /></el-form-item>
              <el-form-item label="市场参考价（元）"
                ><el-input v-model="form.market_price" placeholder="可留空"
              /></el-form-item>
              <el-form-item label="立省金额（元）"
                ><el-input v-model="form.saving_amount" placeholder="可留空"
              /></el-form-item>
            </div>
            <el-form-item label="价格同步"
              ><el-checkbox v-model="autoSaving">价格变动时自动计算立省</el-checkbox>
              <div class="muted">
                优先使用市场参考价；未填写时使用参考原价。发布价与对单金额同步保存。
              </div></el-form-item
            >
            <el-form-item label="资产描述"
              ><el-input v-model="form.asset_desc" type="textarea" :rows="4" maxlength="500"
            /></el-form-item>
            <el-form-item label="实物图片">
              <div class="image-list">
                <div v-for="(image, index) in images" :key="image.file_id" class="image-item">
                  <el-image
                    :src="image.file_path || image.file_url"
                    fit="cover"
                    :preview-src-list="images.map((item) => item.file_path || item.file_url)"
                  />
                  <div v-if="editing">
                    <el-button type="text" :disabled="index === 0" @click="moveCover(index)"
                      >设为封面</el-button
                    ><el-button type="text" @click="images.splice(index, 1)">移除</el-button>
                  </div>
                  <span v-else-if="index === 0" class="muted">封面</span>
                </div>
              </div>
              <el-button v-if="editing" @click="isUpload = true">选择图片</el-button>
              <div class="muted">变更图片需保留4–21张，首张为封面；历史图片未修改时保留原样。</div>
            </el-form-item>
          </el-form>
          <div class="state-actions" v-if="!editing">
            <template v-if="!Number(detail.order.is_delete)">
              <el-button
                v-for="(label, value) in statuses"
                :key="value"
                v-auth="'/issueorder/cashoutv2/status'"
                :disabled="saving || Number(value) === Number(detail.order.status)"
                @click="change('status', value)"
                >{{
                  value == 10 ? '上架 / 待撮合' : value == 30 ? '下架 / 关闭' : '设为' + label
                }}</el-button
              >
              <el-button
                v-auth="'/issueorder/cashoutv2/delete'"
                type="danger"
                plain
                :disabled="saving"
                @click="change('delete')"
                >删除</el-button
              >
            </template>
            <el-button
              v-else
              v-auth="'/issueorder/cashoutv2/restore'"
              :disabled="saving"
              @click="change('restore')"
              >恢复记录</el-button
            >
          </div>
        </div>
      </div>
      <div slot="footer">
        <el-button :disabled="saving" @click="visible = false">关闭</el-button
        ><el-button
          v-if="editing && detail"
          type="primary"
          :loading="saving"
          :disabled="detailLoading || detailError"
          @click="save"
          >保存</el-button
        >
      </div>
    </el-dialog>
    <Upload v-if="isUpload" :config="{ total: 21, file_type: 'image' }" @returnImgs="onImages" />
  </div>
</template>

<script>
import request from '@/utils/request';
import Upload from '@/components/file/Upload';
const base = '/shop/issueorder.cashoutv2/';
const split = (value) =>
  String(value || '')
    .split(',')
    .filter(Boolean);
export default {
  components: { Upload },
  data() {
    return {
      list: [],
      total: 0,
      statuses: {},
      search: { title: '', status: '', deleted: '0', page: 1 },
      loading: false,
      visible: false,
      editing: false,
      detailLoading: false,
      detailError: false,
      saving: false,
      isUpload: false,
      activeRow: null,
      detail: null,
      config: { options: {}, cities: [] },
      form: {},
      original: {},
      images: [],
      originalImages: [],
      autoSaving: true,
      listSerial: 0,
      detailSerial: 0,
      selectFields: [
        { key: 'asset_category', label: '资产类别' },
        { key: 'condition_code', label: '商品成色' },
        { key: 'is_negotiable', label: '议价设置' },
        { key: 'urgency_level', label: '紧急程度' },
        { key: 'circulation_modes', label: '流通方式', multiple: true },
        { key: 'delivery_modes', label: '交付方式', multiple: true },
        { key: 'quantity_mode', label: '数量模式' },
        { key: 'tag_codes', label: '资源标签', multiple: true },
      ],
    };
  },
  computed: {
    priceMismatch() {
      return (
        this.detail &&
        this.detail.biz.sale_price !== null &&
        Number(this.detail.order.money) !== Number(this.detail.biz.sale_price)
      );
    },
    cityOptions() {
      const cities = this.config.cities.slice();
      if (this.form.city_id && !cities.some((item) => item.value === this.form.city_id))
        cities.push({
          value: this.form.city_id,
          label: '历史城市（' + this.form.city_id + '）',
          disabled: true,
        });
      return cities;
    },
  },
  created() {
    this.load(1);
    if (this.$route.query.id) this.open({ id: Number(this.$route.query.id) }, true);
  },
  beforeDestroy() {
    ++this.listSerial;
    ++this.detailSerial;
  },
  methods: {
    load(page) {
      const serial = ++this.listSerial;
      this.search.page = page;
      this.loading = true;
      return request
        ._get(base + 'index', this.search)
        .then((res) => {
          if (serial !== this.listSerial) return;
          this.list = res.data.list.data;
          this.total = res.data.list.total;
          this.statuses = res.data.statuses;
        })
        .catch(() => {
          if (serial === this.listSerial) this.list = [];
        })
        .finally(() => {
          if (serial === this.listSerial) this.loading = false;
        });
    },
    open(row, editing) {
      const serial = ++this.detailSerial;
      this.activeRow = row;
      this.editing = editing;
      this.visible = true;
      this.detail = null;
      this.detailLoading = true;
      this.detailError = false;
      return Promise.all([
        request._get(base + 'detail', { id: row.id }),
        request._get(base + 'config'),
      ])
        .then(([res, cfg]) => {
          if (serial !== this.detailSerial) return;
          this.detail = res.data;
          this.config = cfg.data;
          this.autoSaving = true;
          const order = res.data.order,
            biz = res.data.biz;
          const form = {
            title: order.title,
            brand: biz.brand || '',
            asset_desc: biz.asset_desc || '',
            city_id: Number(biz.city_id || 0),
            quantity: Number(biz.quantity || 1),
            sale_price: String(order.money),
            estimate_value: String(biz.estimate_value),
            market_price: biz.market_price === null ? '' : String(biz.market_price),
            saving_amount: biz.saving_amount === null ? '' : String(biz.saving_amount),
          };
          this.selectFields.forEach((field) => {
            const value = field.key === 'tag_codes' ? order.tag_codes : biz[field.key];
            form[field.key] = field.multiple ? split(value) : String(value == null ? '' : value);
          });
          this.form = form;
          this.original = JSON.parse(JSON.stringify(form));
          const seen = new Set();
          this.images = res.data.images
            .filter((image) => ['proof_images', 'cashout_proof'].includes(image.biz_file_type))
            .filter((image) => {
              if (seen.has(image.file_id)) return false;
              seen.add(image.file_id);
              return true;
            });
          this.originalImages = this.images.map((image) => Number(image.file_id));
        })
        .catch(() => {
          if (serial === this.detailSerial) this.detailError = true;
        })
        .finally(() => {
          if (serial === this.detailSerial) this.detailLoading = false;
        });
    },
    fieldOptions(key) {
      const options = (this.config.options[key] || []).map((item) => ({
        value: String(item.value),
        label: item.label,
      }));
      let labels = {};
      try {
        labels = JSON.parse(this.detail.biz.option_labels || '{}');
      } catch (e) {
        /* 历史数据无快照 */
      }
      const values = Array.isArray(this.original[key]) ? this.original[key] : [this.original[key]];
      values
        .filter((value) => value !== undefined && value !== '')
        .forEach((value) => {
          if (!options.some((item) => item.value === value))
            options.push({
              value,
              label: (labels[key] && labels[key][value]) || '历史选项：' + value,
              disabled: true,
            });
        });
      return options;
    },
    moveCover(index) {
      this.images.unshift(this.images.splice(index, 1)[0]);
    },
    onImages(list) {
      this.isUpload = false;
      if (!Array.isArray(list)) return;
      const seen = new Set(this.images.map((image) => Number(image.file_id)));
      list.forEach((image) => {
        if (this.images.length < 21 && !seen.has(Number(image.file_id))) {
          this.images.push(image);
          seen.add(Number(image.file_id));
        }
      });
    },
    save() {
      if (this.saving) return;
      const fields = {};
      Object.keys(this.form).forEach((key) => {
        if (JSON.stringify(this.form[key]) !== JSON.stringify(this.original[key]))
          fields[key] = this.form[key];
      });
      if (this.priceMismatch) fields.sale_price = this.form.sale_price;
      if (
        this.autoSaving &&
        ['sale_price', 'market_price', 'estimate_value'].some((key) =>
          Object.prototype.hasOwnProperty.call(fields, key)
        )
      )
        delete fields.saving_amount;
      const params = {
        id: this.detail.order.id,
        version: this.detail.version,
        fields: JSON.stringify(fields),
      };
      const imageIds = this.images.map((image) => Number(image.file_id));
      if (JSON.stringify(imageIds) !== JSON.stringify(this.originalImages))
        params.image_ids = JSON.stringify(imageIds);
      this.saving = true;
      request
        ._post(base + 'edit', params)
        .then(() => {
          this.$message.success('已保存');
          this.visible = false;
          this.load(this.search.page);
        })
        .catch(() => {})
        .finally(() => {
          this.saving = false;
        });
    },
    change(action, status) {
      if (this.saving) return;
      const labels = { delete: '删除此记录（可恢复）', restore: '恢复此记录' };
      const label = action === 'status' ? '将状态设为' + this.statuses[status] : labels[action];
      this.$confirm(label + '？', '确认操作', { type: 'warning' })
        .then(() => {
          this.saving = true;
          return request
            ._post(base + action, {
              id: this.detail.order.id,
              version: this.detail.version,
              status,
            })
            .then(() => {
              this.$message.success('操作成功');
              this.visible = false;
              this.load(this.search.page);
            })
            .finally(() => {
              this.saving = false;
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.filters {
  margin-top: 18px;
}
.field-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.field-grid .el-select {
  width: 100%;
}
.muted {
  color: #909399;
  font-size: 12px;
  line-height: 22px;
}
.image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.image-item {
  width: 105px;
}
.image-item .el-image {
  width: 100px;
  height: 80px;
  border-radius: 6px;
}
.image-item .el-button {
  font-size: 11px;
}
.state-actions {
  border-top: 1px solid #eee;
  padding-top: 18px;
}
</style>



// WEBPACK FOOTER //
// src/views/issueorder/cashoutv2/index.vue